import React, { useMemo } from 'react';
import { Card, Progress, Space, Tag, Typography } from 'antd';
import type { ExecutionDashboardSlice, ExecutionProgressHydration } from './types';
import {
  computeExecutionProgressView,
  deriveRouteOperationalStatus,
  getActiveExecutionStop
} from '../routes/execution';
import { enrichStops } from './executionHelpers';
import { getExecutionStatusBadgeProps, normalizeOperationalState } from '../routes/execution/statusFacade';

const { Text } = Typography;

type Props = {
  routeId: number;
  hydration: ExecutionProgressHydration | null | undefined;
  dashboard?: ExecutionDashboardSlice | null;
  legacyStatus?: string | null;
};

/** Compact dispatcher-friendly execution card for mobile / workspace strips. */
export const ExecutionCompactCard: React.FC<Props> = ({ routeId, hydration, dashboard }) => {
  const routeStatus = useMemo(() => deriveRouteOperationalStatus(hydration), [hydration]);
  const progressView = useMemo(
    () => computeExecutionProgressView({ hydration, dashboard }),
    [hydration, dashboard]
  );

  if (!hydration) {
    return (
      <Card size="small">
        <Text type="secondary">Маршрут #{routeId}: исполнение не инициализировано</Text>
      </Card>
    );
  }

  const stops = enrichStops(hydration);
  const active = getActiveExecutionStop(hydration, stops, new Map());
  const overall = progressView?.routePercent ?? hydration.progress.overallPercent;

  return (
    <Card size="small" title={`Исполнение · маршрут #${routeId}`}>
      <Progress percent={overall} size="small" />
      <Space wrap style={{ marginTop: 8 }}>
        <Tag color={routeStatus.color}>{routeStatus.label}</Tag>
      </Space>
      {active ? (
        <div style={{ marginTop: 8 }}>
          <Text style={{ fontSize: 12 }}>
            {active.typeLabel}: {active.statusLabel}
          </Text>
          <br />
          <Tag
            color={getExecutionStatusBadgeProps(normalizeOperationalState(active.stop.executionState)).color}
            style={{ marginTop: 4 }}
          >
            {active.address ?? 'Адрес не указан'}
          </Tag>
        </div>
      ) : (
        <Text type="success" style={{ display: 'block', marginTop: 8, fontSize: 12 }}>
          Исполнение завершено
        </Text>
      )}
    </Card>
  );
};

export default ExecutionCompactCard;
